(function () {
  var AVATAR_SRC = 'https://cdn.shopify.com/s/files/1/0934/0331/6553/files/Faveicon_IT_Minci_Delice_Regime_hyperproteine.png?v=1749547710';

  function decodeHtml(str) {
    var d = document.createElement('div');
    d.innerHTML = str;
    return d.textContent || d.innerText || str;
  }

  function isMobile() {
    return window.innerWidth < 768;
  }

  function initChatExplainer() {
    var trigger  = document.getElementById('chat-explainer-trigger');
    var modal    = document.getElementById('chat-modal');
    var closeBtn = document.getElementById('chat-modal-close');
    var body     = document.getElementById('chat-modal-body');
    var dataEl   = document.getElementById('chat-script-data');
    var panel    = modal ? modal.querySelector('.chat-modal__panel') : null;

    if (!trigger || !modal || !dataEl || !panel) return;

    /* Déplacer le modal comme enfant direct de <body>
       pour échapper au transform du wrapper Impulse */
    document.body.appendChild(modal);

    var script = [];
    try { script = JSON.parse(dataEl.textContent); } catch (e) {}

    var played = false;

    function openModal() {
      /* Position fixed fonctionne maintenant car le modal
         est un enfant direct de <body> sans transform parent */
      modal.style.setProperty('display',          'block',                   'important');
      modal.style.setProperty('position',         'fixed',                   'important');
      modal.style.setProperty('inset',            '0',                       'important');
      modal.style.setProperty('z-index',          '99998',                   'important');
      modal.style.setProperty('pointer-events',   'auto',                    'important');
      modal.style.setProperty('background',       'rgba(0,0,0,0.28)',        'important');
      modal.style.setProperty('backdrop-filter',  'blur(2px)',               'important');

      if (isMobile()) {
        panel.style.setProperty('position',      'fixed',                       'important');
        panel.style.setProperty('bottom',        '0',                           'important');
        panel.style.setProperty('left',          '0',                           'important');
        panel.style.setProperty('right',         '0',                           'important');
        panel.style.setProperty('top',           'auto',                        'important');
        panel.style.setProperty('width',         '100%',                        'important');
        panel.style.setProperty('height',        '72vh',                        'important');
        panel.style.setProperty('border-radius', '20px 20px 0 0',              'important');
        panel.style.setProperty('transform',     'none',                        'important');
      } else {
        var vpW    = window.innerWidth;
        var vpH    = window.innerHeight;
        var pw     = Math.min(680, vpW * 0.92);
        var ph     = Math.min(Math.round(vpH * 0.78), 700);
        panel.style.setProperty('position',      'fixed',                       'important');
        panel.style.setProperty('top',           '50%',                         'important');
        panel.style.setProperty('left',          '50%',                         'important');
        panel.style.setProperty('transform',     'translate(-50%,-50%)',        'important');
        panel.style.setProperty('bottom',        'auto',                        'important');
        panel.style.setProperty('right',         'auto',                        'important');
        panel.style.setProperty('width',         pw + 'px',                     'important');
        panel.style.setProperty('height',        ph + 'px',                     'important');
        panel.style.setProperty('border-radius', '20px',                        'important');
      }

      panel.style.setProperty('background',     '#fff',                         'important');
      panel.style.setProperty('display',        'flex',                         'important');
      panel.style.setProperty('flex-direction', 'column',                       'important');
      panel.style.setProperty('overflow',       'hidden',                       'important');
      panel.style.setProperty('z-index',        '99999',                        'important');
      panel.style.setProperty('box-shadow',     '0 8px 48px rgba(0,0,0,0.22)', 'important');

      document.documentElement.style.overflow = 'hidden';

      if (!played) { played = true; renderScript(); }
    }

    function closeModal() {
      modal.style.setProperty('display', 'none', 'important');
      document.documentElement.style.overflow = '';
    }

    trigger.addEventListener('click', openModal);

    closeBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      closeModal();
    });

    modal.addEventListener('click', function (e) {
      if (!panel.contains(e.target)) closeModal();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });

    function renderScript() {
      var prevType = null;

      script.forEach(function (msg) {
        var isBrand = (msg.type === 'brand' || msg.type === 'image');
        var showAvatar = isBrand && prevType !== 'brand';

        if (msg.type === 'image') {
          var row = document.createElement('div');
          row.className = 'bubble-row bubble-row--brand';
          if (showAvatar) {
            var av = document.createElement('img');
            av.src = AVATAR_SRC; av.className = 'bubble-avatar-small';
            row.appendChild(av);
          } else {
            var sp = document.createElement('div');
            sp.className = 'bubble-avatar-placeholder';
            row.appendChild(sp);
          }
          var img = document.createElement('img');
          img.src = msg.src; img.alt = msg.alt || ''; img.className = 'bubble-image';
          row.appendChild(img);
          body.appendChild(row);

        } else if (msg.type === 'brand') {
          var row = document.createElement('div');
          row.className = 'bubble-row bubble-row--brand';
          if (showAvatar) {
            var av = document.createElement('img');
            av.src = AVATAR_SRC; av.className = 'bubble-avatar-small';
            row.appendChild(av);
          } else {
            var sp = document.createElement('div');
            sp.className = 'bubble-avatar-placeholder';
            row.appendChild(sp);
          }
          var bubble = document.createElement('div');
          bubble.className = 'bubble bubble--brand';
          bubble.textContent = decodeHtml(msg.text);
          row.appendChild(bubble);
          body.appendChild(row);

        } else if (msg.type === 'buttons') {
          var wrap = document.createElement('div');
          wrap.className = 'chat-cta-buttons';
          msg.items.forEach(function(item) {
            var btn = document.createElement('a');
            btn.href = item.url;
            btn.className = 'chat-cta-btn';
            var left = document.createElement('div');
            left.className = 'chat-cta-btn__left';
            var lbl = document.createElement('span');
            lbl.className = 'chat-cta-btn__label';
            lbl.textContent = decodeHtml(item.label);
            var sub = document.createElement('span');
            sub.className = 'chat-cta-btn__sub';
            sub.textContent = decodeHtml(item.sub);
            left.appendChild(lbl);
            left.appendChild(sub);
            var arrow = document.createElement('span');
            arrow.className = 'chat-cta-btn__arrow';
            arrow.textContent = '→';
            btn.appendChild(left);
            btn.appendChild(arrow);
            wrap.appendChild(btn);
          });
          body.appendChild(wrap);
          prevType = null;

        } else {
          var bubble = document.createElement('div');
          bubble.className = 'bubble bubble--user';
          bubble.textContent = decodeHtml(msg.text);
          body.appendChild(bubble);
        }

        if (msg.type !== 'buttons') prevType = isBrand ? 'brand' : 'user';
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initChatExplainer);
  } else {
    initChatExplainer();
  }
})();
